<div class="form-field-container" class="{{class}}" [ngClass]="{'form-field-row': layout === 'row'}">
  @if (showHeader) {
    <div class="form-field-header">
      <div class="form-field-title-container">
        @if (titleIcon) {
          <div class="title-icon {{titleIcon}}"></div>
        }
        <span class="form-field-title">{{title}}</span>
        @if (helpText) {
          <div
            class="form-field-help-icon"
            matTooltip="{{helpText}}"
            matTooltipPosition="below"
            (click)="onHelpClick()"
          >?</div>
        }
      </div>
      @if (label) {
        <span class="form-field-label">{{label}}</span>
      }
      @if (count || count === 0) {
        <span class="form-field-count">{{count}}</span>
      }
      @if (title2) {
        <div class="form-field-title-container title-container-2">
          <span class="form-field-title title2">{{title2}}</span>
          @if (helpText2) {
            <div
              class="form-field-info infoicon"
              matTooltip="{{helpText2}}"
              matTooltipPosition="below"
            ></div>
          }
        </div>
      }
      @if (showToggle) {
        <div class="form-header-toggle-container">
          <span
            class="toggle-option-text"
            [ngClass]="{'toggle-option-selected': !headerToggle}"
            (click)="toggleHeader('left')"
            >
            OFF
          </span>
          <div class="form-header-toggle" (click)="toggleHeader()">
            <div
              class="form-toggle-switch form-toggle-switch-inverse"
              [ngClass]="{'toggle-left': !headerToggle, 'toggle-right': headerToggle}"
              >
              <div class="form-toggle-indicator"></div>
              <div class="form-toggle-indicator"></div>
            </div>
          </div>
          <span
            class="toggle-option-text"
            [ngClass]="{'toggle-option-selected': headerToggle}"
            (click)="toggleHeader('right')"
            >
            ON
          </span>
        </div>
      }
    </div>
  }
  <div class="form-field-content" [style]="contentStyle" class="{{contentClass}}">
    <ng-content></ng-content>
  </div>
  @if (headerActions) {
    <lib-multi-action-button
      [actions]="headerActions"
      (actionRequested)="actionClicked($event)"
    ></lib-multi-action-button>
  }
</div>
